(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-grouping"] && !Shopify.designMode) return;
  try {
    /*
   * Grouping options. 'update' swaps the card's link, title, price and image
   * from data already in the markup — no request, so the switch is instant;
   * 'link' follows the option; 'add' posts to the cart and then fires the
   * theme's own cart event so the drawer and the bubble refresh.
   */
  class ProductGroupingComponent extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      this.addEventListener('change', this.#onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.removeEventListener('change', this.#onChange);
    }

    #onChange = (event) => {
      const select = event.target.closest('select');
      if (!select) return;
      this.#activate(select.options[select.selectedIndex]);
    };

    #onClick = (event) => {
      const option = event.target.closest('.product-grouping__option');
      if (!option) return;
      if (this.dataset.behaviour === 'link') return; // native navigation
      event.preventDefault();
      this.#activate(option);
    };

    #activate(option) {
      if (this.dataset.behaviour === 'add') {
        this.#addToCart(option);
        return;
      }
      this.#updateCard(option);
    }

    #updateCard(option) {
      const card = this.closest('product-card') || this.closest('.product-card, .card');
      if (!card) return;

      for (const selected of this.querySelectorAll('.product-grouping__option--selected')) {
        selected.classList.remove('product-grouping__option--selected');
        selected.removeAttribute('aria-current');
      }
      if (option.classList) {
        option.classList.add('product-grouping__option--selected');
        option.setAttribute('aria-current', 'true');
      }

      const { productUrl, productTitle, productPrice, productImage, productImageHover } = option.dataset;

      for (const link of card.querySelectorAll('a[href]')) {
        if (!link.closest('product-grouping-component')) link.href = productUrl;
      }

      // The title block wraps its text in a link carrying ref="productTitleLink";
      // the text itself is the innermost heading, not a class we can rely on.
      const titleLink = card.querySelector('[ref="productTitleLink"]');
      const titleNode =
        titleLink?.querySelector('[role="heading"], h1, h2, h3, h4, h5, h6, p') || titleLink;
      if (titleNode && productTitle) titleNode.textContent = productTitle;

      const price = card.querySelector('product-price .price, product-price, .price');
      if (price && productPrice) price.innerHTML = productPrice;

      /* Toutes les images de la galerie, pas seulement la première : la seconde
         diapo est celle du survol, et elle gardait l'image de l'ancien produit —
         mesuré : diapo 1 remplacée, diapo 2 toujours « vue-motif…liquid ». Le
         nouveau produit sans seconde image reprend sa première, pour que le
         survol ne montre jamais un autre produit. */
      const images = card.querySelectorAll('.card-gallery slideshow-slide img');
      const sources = [productImage, productImageHover || productImage];
      if (images.length && productImage) {
        images.forEach((img, i) => {
          img.removeAttribute('srcset');
          img.src = sources[Math.min(i, 1)];
        });
      } else {
        const image = card.querySelector('img');
        if (image && productImage) {
          image.removeAttribute('srcset');
          image.src = productImage;
        }
      }

      this.#syncButton(card, option);
    }

    /*
     * Le bouton d'ajout doit parler du produit AFFICHÉ, pas de celui qui a servi au
     * rendu : sans cela un « Choisir » restait sur une déclinaison à variante unique,
     * et « Ajouter » aurait ajouté la mauvaise variante.
     *
     * Le thème choisit le libellé en CSS, sur la PRÉSENCE du compagnon
     * `.add-to-cart-block__preview` — on ajoute ou on retire ce compagnon plutôt que de
     * redéfinir la règle, pour que toutes les autres cartes gardent leur comportement.
     */
    #syncButton(card, option) {
      const block = card.querySelector('.add-to-cart-block');
      const button = block?.querySelector('.add-to-cart-button');
      if (!block || !button) return;

      const state = option.dataset.buttonState || 'add';
      const { productUrl, productTitle, productId, variantId } = option.dataset;

      /* La variante ajoutée : le formulaire de la carte pointe encore l'ancien produit.
         Il ENVELOPPE le bouton, il ne vit pas dedans — et celui du regroupement, quand le
         comportement est « Ajouter au panier », ne doit surtout pas être touché. */
      const form = [...card.querySelectorAll('product-form-component')].find(
        (f) => !f.closest('product-grouping-component')
      );
      const variantField = form?.querySelector('[ref="variantId"], input[name="id"]');
      if (variantField && variantId) variantField.value = variantId;
      if (form && productId) form.dataset.productId = productId;

      const normalLabel = button.querySelector(
        '.add-to-cart-button__label:not(.add-to-cart-button__label--alt)'
      );
      let altLabel = button.querySelector('.add-to-cart-button__label--alt');
      let companion = block.querySelector('.add-to-cart-block__preview');

      if (state === 'choose') {
        if (!companion) {
          companion = document.createElement('quick-add-component');
          companion.className = 'add-to-cart-block__preview';
          companion.hidden = true;
          companion.dataset.quickAddButton = 'choose';
          companion.dataset.usesSellingPlans = 'false';
          companion.dataset.previewIfNoChoice = 'true';
          block.insertBefore(companion, block.firstChild);
        }
        companion.dataset.productUrl = productUrl || '';
        companion.dataset.productTitle = productTitle || '';
        if (productId) companion.dataset.productId = productId;
        if (!altLabel) {
          altLabel = document.createElement('span');
          altLabel.className = 'add-to-cart-button__label add-to-cart-button__label--alt';
          normalLabel?.after(altLabel);
        }
        altLabel.textContent = this.dataset.labelChoose || altLabel.textContent;
      } else {
        /* Les deux libellés vivent côte à côte et c'est le compagnon qui décide lequel
           s'affiche : sans lui, le second resterait visible à côté du premier. */
        companion?.remove();
        altLabel?.remove();
      }

      const soldOut = state === 'sold-out';
      button.disabled = soldOut;
      if (normalLabel) {
        normalLabel.textContent = soldOut
          ? this.dataset.labelSoldOut || normalLabel.textContent
          : this.dataset.labelAdd || normalLabel.textContent;
      }
    }

    #addToCart(option) {
      const variantId = option.dataset.variantId;
      if (!variantId || option.dataset.available !== 'true') return;

      const form = this.querySelector('product-form-component');
      const variantInput = this.querySelector('[ref="variantId"]');
      if (!form || !variantInput || typeof form.handleSubmit !== 'function') return;

      variantInput.value = variantId;

      // Hand it to the theme rather than posting ourselves: handleSubmit is what
      // fires CartLinesUpdateEvent, which is what opens the drawer and updates
      // the bubble. A bare /cart/add.js call adds the line and tells no one.
      option.setAttribute?.('aria-busy', 'true');
      form.handleSubmit(new Event('submit', { cancelable: true, bubbles: true }));
      setTimeout(() => option.removeAttribute?.('aria-busy'), 600);
    }
  }

  if (!customElements.get('product-grouping-component')) {
    customElements.define('product-grouping-component', ProductGroupingComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-filters"] && !Shopify.designMode) return;
  try {
    const PILL = '.facets-bar .filters-toggle-block[data-facets-floating]';
  let booted = false;
  let frame = null;

  const sync = () => {
    frame = null;
    for (const pill of document.querySelectorAll(PILL)) {
      /* Bornée par sa propre section : une page peut porter plusieurs `.collection-wrapper`. */
      const section = pill.closest('.shopify-section') || pill.closest('.collection-wrapper');
      if (!section) continue;

      /* On vise la grille de produits, pas la section : une bannière haute l'afficherait avant tout produit. */
      const products = section.querySelector('.collection-wrapper, .product-grid, .resource-list') || section;
      const rect = products.getBoundingClientRect();

      const height = pill.getBoundingClientRect().height;
      const styles = getComputedStyle(pill);
      const atTop = styles.getPropertyValue('inset-block-end') === 'auto';
      const line = atTop
        ? (parseFloat(styles.getPropertyValue('inset-block-start')) || 0) + height
        : window.innerHeight - (parseFloat(styles.getPropertyValue('inset-block-end')) || 0) - height;

      const onScreen = rect.top <= line && rect.bottom > 0;
      pill.toggleAttribute('data-out-of-section', !onScreen);
      if (!onScreen) continue;

      pill.style.removeProperty('--facets-floating-shift');
    }
  };

  const schedule = () => {
    if (frame == null) frame = requestAnimationFrame(sync);
  };

  const boot = () => {
    if (booted || !document.querySelector(PILL)) return;
    booted = true;
    sync();
    addEventListener('load', sync, { once: true });
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    addEventListener('resize', schedule, { passive: true });
  };

  boot();
  document.addEventListener('shopify:section:load', () => {
    boot();
    schedule();
  });
  } catch(e) { console.error(e); }
})();

})();
